import { c as _c } from "react/compiler-runtime";
import { Heading, Text, VStack } from '@chakra-ui/react';
export const StatBox = t0 => {
  const $ = _c(7);
  const {
    value,
    label
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <Heading lineHeight={1} size="lg">{value}</Heading>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <Text color="colorPalette.fg/50" textAlign="center" textStyle="label2xs">{label}</Text>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <VStack flex={1} gap={0.5} paddingY={2}>{t1}{t2}</VStack>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};